type ValidVideoPartnersType = {
  [key: string]: {
    displayName: string;
    redirectUrl: string;
    requiredParams: string[];
  };
};

type IntegrationRedirectStatesType = {
  [key: string | number]: string | number;
};

export const INTEGRATION_LANDING_PAGE = '/videopartner';
export const IS_EXISTING_USER_KEY = 'isExistingUser';
export const INTEGRATION_REDIRECT_STATES: IntegrationRedirectStatesType = {
  COMPLETE: 'complete',
  CONFIRMATION: 'confirmation',
  FAIL: 'fail',
  IDLE: 'idle',
  PODCAST: 'podcast',
  SUCCESS: 'success',
};
export type IntegrationRedirectStates = keyof typeof INTEGRATION_REDIRECT_STATES;
export const VALID_VIDEO_PARTNERS: ValidVideoPartnersType = {
  riverside: {
    displayName: 'Riverside.fm',
    redirectUrl: 'http://riverside.fm/',
    requiredParams: ['clipHash'],
  },
};

export const RIVERSIDE_ENTRY_POINT_ALLOWED_COUNTRIES = [
  'US',
  'GB',
  'CA',
  'AU',
  'NZ',
];
